// extracted by mini-css-extract-plugin
export var content = "hero-module--content--RTC98";
export var contentWrapper = "hero-module--contentWrapper--l5s+W";
export var fontsLoading = "hero-module--fonts-loading--x+0ql";
export var heading = "hero-module--heading--hb3vy";
export var heroWrapper = "hero-module--heroWrapper--1MoGB";
export var subHeading = "hero-module--subHeading--1Z5UP";